<header class="header-full ">
    <div class="row">
        <div class="col-3 pt-3 pl-5">
            <img src="assets/img/logo-white.png">
        </div>
        <div class="col-4 offset-5">

            <div class="row ">
                <div class="col-4 text-usr text-right">
                    <h6 class="mt-3"> {{ sexoCliente }} </h6>
                    <h5> {{ nombreCliente }} </h5>
                </div>
                <div class="col-2 user-header pl-0"> <img src="assets/img/user.png">
                </div>

                <div class="col-6 exit-header">
                    <a href="#" (click)="exit($event)">
                        <img src="assets/img/exit.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
</header>

<img class="w-100" [src] = "imgHeader" alt="">
<div class="row text-center" *ngIf="titleHeader">
    <div class="col-12 box-title">
        <h2 class="text-blue" [innerHTML] = "titleHeader"></h2>
    </div>
</div>
